'use strict';
/**
 * expireDuplicateSessionCookies
 *
 * Ensures the session ID cookie is unique. Prevents
 * CSRF validation bug.
 *
 */
function expireDuplicateSessionCookies() {
  // Split document.cookie on semicolons into an array of strings
  var cookieArray = document.cookie.split(';');

  var phpSessidCount = 0;

  // Loop through the array of cookie strings
  for (var i = 0; i < cookieArray.length; i++) {
      // Trim leading and trailing whitespace from the cookie string
      var cookie = cookieArray[i].trim();

      // Check if the cookie is 'PHPSESSID'
      if (cookie.startsWith('PHPSESSID=')) {
          phpSessidCount++;
          if (phpSessidCount > 1) {
              // Expire the 'PHPSESSID' cookie if there are multiple entries
              document.cookie = "PHPSESSID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
              return true; // Return true if duplicate found and expired.
          }
      }
  }

  // Return false if no duplicates.
  return false;
}

// Execute the function as a non-blocking operation after the page has loaded
window.addEventListener('load', function() {
  setTimeout(expireDuplicateSessionCookies, 100);
});
